import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({
      to: "/all-chats",
    }).catch((e: Error) => {
      console.error("Could not redirect", e);
      window.location.assign("/all-chats");
    });
  }, [navigate]);

  return <></>;
}
